import { apiGet } from '../../api'

export const get_all_assets = () => {
  return apiGet({
    endpoint: 'asset/get_all_assets'
  })
}
